module.exports = __webpack_public_path__ + "static/media/playflowplugin.34937969.png";